import React from "react";

interface BarIconProps {
    isActive: boolean;
}

const BarIcon: React.FC<BarIconProps> = ({ isActive }) => {
    let color = isActive ? "#0F7679" : "#6A7878"
    return (
        <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.4615 15.75V10.0192L0.35375 2.01925C0.248917 1.91158 0.16375 1.78708 0.0982502 1.64575C0.0327502 1.50442 0 1.35967 0 1.2115C0 0.861501 0.12025 0.572083 0.36075 0.34325C0.601084 0.114416 0.894917 0 1.24225 0H15.1808C15.5281 0 15.8219 0.114083 16.0623 0.34225C16.3028 0.57025 16.423 0.858666 16.423 1.2075C16.423 1.355 16.3903 1.5 16.3248 1.6425C16.2593 1.785 16.1741 1.91058 16.0693 2.01925L8.9615 10.0192V15.75H12.9615C13.174 15.75 13.3521 15.8219 13.4958 15.9658C13.6396 16.1096 13.7115 16.2878 13.7115 16.5002C13.7115 16.7129 13.6396 16.891 13.4958 17.0345C13.3521 17.1782 13.174 17.25 12.9615 17.25H3.4615C3.249 17.25 3.07092 17.1781 2.92725 17.0343C2.78342 16.8904 2.7115 16.7122 2.7115 16.4998C2.7115 16.2871 2.78342 16.109 2.92725 15.9655C3.07092 15.8218 3.249 15.75 3.4615 15.75H7.4615ZM3.6615 3.5H12.7615L14.5615 1.5H1.8615L3.6615 3.5ZM8.2115 8.6L11.4288 5H4.99425L8.2115 8.6Z" fill={color} />
        </svg>

    )
}
export default BarIcon;